// Configured in the AWS Amplify Console as a build-time environment variable
// https://eu-central-1.console.aws.amazon.com/amplify/apps/d2sju6gfvitb5s/build
export const getCommitSha = () =>  process.env.REACT_APP_COMMIT_SHA || 'Unknown GIT SHA';